module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(n, index) {
    return _c('md-notification', {
      key: n,
      attrs: {
        "message": n.message,
        "icon": n.icon,
        "type": n.type,
        "placement": n.placement
      },
      on: {
        "onClose": function($event) {
          return _vm.removeNotification(index)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bab420","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdNotifications/index.vue
// module id = 1469
// module chunks = 0